<template>
    <div>
        <div class="img_47 tel">
            <input placeholder="请输入手机号" v-model="form.tel" maxlength="11">
        </div>
        <div class="captcha">
            <div class="img_48 ">
                <input placeholder="请输入验证码" maxlength="10" v-model="form.captcha">
            </div>
            <div class="captcha_box">
                <div v-text="number" v-if="number!==0" class="img_41 number"></div>
                <div class="img_45 cursor" v-else @click="get_code"></div>
            </div>
        </div>
        <div class="agreement" @click="form.agreement = !form.agreement">
            <div :class="form.agreement?'img_68':'img_67'"></div>
            <div class="img_51"></div>
            <a href="https://xytx.firewick.net/ag.html?type=user_protocol" @click.stop="" class="user cursor"></a>
            <a href="https://xytx.firewick.net/ag.html?type=private_policy" @click.stop="" class="privacy cursor"></a>
        </div>
        <div class="img_57 login_bottom cursor" @click="login_bottom"></div>
    </div>
</template>

<script>
module.exports = {
    data() {
        return {
            number: 0,
            form  : {
                tel      : '',
                captcha  : '',
                agreement: false
            },
            time  : null,
        }
    },
    methods: {
        not_fn() {
        },
        login_bottom() {
            var tel     = this.form.tel,
                captcha = this.form.captcha
            console.log(this.form)
            if (!tel || !captcha) {
                return this.$top_box.show_box('请输入手机号和验证码')
            }
            if (!this.form.agreement) {
                return this.$top_box.show_box('请同意协议')
            }
            this.$httpr.login(tel, captcha, this.user_data.shave_tel, (err, data) => {
                console.log('get_code err', err, data)
                if (data && data.ok) {
                    this.user_data.account = data.data
                    this.$emit('close', data.data)
                } else {
                    this.$top_box.show_box(err || (data && data.err || data.msg) || '系统异常')
                }
            })
        },
        get_code() {
            console.log('form', this.form)
            var tel = this.form.tel
            if (this.time) {
                return
            }
            var test = /1(\d){10}/
            if (!test.test(tel)) {
                return this.$top_box.show_box('请输入正确手机号')
            }
            this.$httpr.get_captcha(tel, (err, data) => {
                console.log('get_code err', err, data)
                err = err ? '网络异常' : (data && data.msg)
                return this.$top_box.show_box(err)
            })
            this.number = 60
            this.time = setInterval(() => {
                this.number--
                if (this.number <= 0) {
                    clearInterval(this.time)
                    return this.time = null
                }
            }, 1000)
        },
    },

}
</script>

<style scoped>
.captcha_box {
    font-size: 0.25rem;
    text-align: center;
    color: #ffffff;
}

.user, .privacy {
    position: absolute;
    width: 1rem;
    height: 100%;
    left: 2rem;
    top: 0rem;
}

.user {
    left: 3rem;
}

.privacy {
    left: 4.3rem;
}

input {
    background-color: transparent;
    font-size: 0.25rem;
    color: #ffffff;
    height: 100%;
    padding-left: .6rem;
}

.captcha input {
    width: 2.3rem;
}

.tel {
    position: absolute;
    left: 50%;
    top: 1rem;
    width: 5.00rem;
    transform: translate(-50%, -50%);
}

.captcha_box {
    margin-left: 0.05rem
}

.number {
    color: #000000;
    text-align: center;
    line-height:.58rem;
}

.captcha {
    position: absolute;
    left: 50%;
    top: 2rem;
    width: 5.00rem;
    transform: translate(-50%, -50%);
}

.captcha div {
    display: inline-block;
    vertical-align: middle;
}

.agreement div {
    display: inline-block;
    vertical-align: middle;
}

.login_bottom {
    position: absolute;
    left: 50%;
    top: 3.5rem;
    transform: translate(-50%, -50%);
}

.agreement {
    position: absolute;
    left: 50%;
    top: 2.8rem;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
}

</style>